function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#C00"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M14 1c1.657 0 3 1.343 3 3v1h4c.513 0 .936.386.993.883L22 6c0 .552-.448 1-1 1h-1v13c0 1.598-1.249 2.904-2.824 2.995L17 23H7c-1.657 0-3-1.343-3-3V7H3c-.513 0-.936-.386-.993-.883L2 6c0-.552.448-1 1-1h4V4c0-1.598 1.249-2.904 2.824-2.995L10 1zm4 6H6v13c0 .513.386.936.883.993L7 21h10c.552 0 1-.448 1-1V7zm-8 3c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1s-1-.448-1-1v-6c0-.552.448-1 1-1zm4 0c.552 0 1 .448 1 1v6c0 .552-.448 1-1 1s-1-.448-1-1v-6c0-.552.448-1 1-1zm0-7h-4c-.552 0-1 .448-1 1v1h6V4c0-.513-.386-.936-.883-.993L14 3z",
  transform: "translate(-1882 -369) translate(1320 100) translate(0 222) translate(0 26) translate(562 21)"
})))))));

var SvgIcTrashRed = function SvgIcTrashRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcTrashRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_trash_red.6e712fd7.svg";
export { ForwardRef as ReactComponent };